var mentions_default = {
  "mentionPalette": "dxQpz",
  "mention": "_5miJY",
  "mentionViewer": "uFDzM",
  "mentionSuggestionsEntry": "pJhXx",
  "mentionSuggestionsEntryFocused": "zQqTG",
  "mentionSuggestionsEntryText": "GSpwX",
  "mentionSuggestionsEntryAvatar": "mKhTh",
  "mentionSuggestions": "_4AwQB",
  "cursorDefault": "_07U0L",
  "cursorPointer": "pZ2zt"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
